import { X } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CloseIcon = createLucideIcon(X);
